import React, { useCallback, useState } from "react";
import { Description } from "@ddm-design-system/typography";
import { PrimaryButton } from "@ddm-design-system/button";
import { useDispatch } from "react-redux";
import SVGTap from "./assets/tap";
import { StyledProgressBar } from "./common.styles";
import { ECleaningUnitButtons, IControlUnit } from "../../../store/installation/types";
import { requestButtonPress } from "../../../store/installation/actions";
import useContent from "../../../hooks/useContent";

export interface IPostRinseProps {
  controlUnit: IControlUnit;
}

const PostRinseMode: React.FC<IPostRinseProps> = ({ controlUnit }) => {
  const { managerAppControlUnit: content, managerAppCommon: common } = useContent();
  const dispatch = useDispatch();
  const [loadingButtonPress, setLoadingButtonPress] = useState(false);

  const handleContinue = useCallback(() => {
    setLoadingButtonPress(true);
    dispatch(
      requestButtonPress({ button: ECleaningUnitButtons.CLEAN, controlUnitId: controlUnit.id })
    );
  }, [controlUnit.id, dispatch]);

  return (
    <div className="flex flex-col gap-xs items-center">
      <SVGTap />
      <div className="flex flex-col gap-md items-center h-full">
        <Description>{content.manager_app_cu_step_postrinse_mode_desc}</Description>
        <StyledProgressBar colorType="water" value={controlUnit.progress} />
        <PrimaryButton
          disabled={controlUnit.progress < 100 || loadingButtonPress}
          onClick={handleContinue}
        >
          {common.common_continue}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default PostRinseMode;
